/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AgentTaskRun } from "./AgentTaskRun";
import {
  AgentTaskRunFromJSON,
  AgentTaskRunFromJSONTyped,
  AgentTaskRunToJSON,
  AgentTaskRunToJSONTyped,
} from "./AgentTaskRun";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { ApiKey } from "./ApiKey";
import {
  ApiKeyFromJSON,
  ApiKeyFromJSONTyped,
  ApiKeyToJSON,
  ApiKeyToJSONTyped,
} from "./ApiKey";
import type { SalesContact } from "./SalesContact";
import {
  SalesContactFromJSON,
  SalesContactFromJSONTyped,
  SalesContactToJSON,
  SalesContactToJSONTyped,
} from "./SalesContact";
import type { CompanyDocument } from "./CompanyDocument";
import {
  CompanyDocumentFromJSON,
  CompanyDocumentFromJSONTyped,
  CompanyDocumentToJSON,
  CompanyDocumentToJSONTyped,
} from "./CompanyDocument";
import type { LinkedCompany } from "./LinkedCompany";
import {
  LinkedCompanyFromJSON,
  LinkedCompanyFromJSONTyped,
  LinkedCompanyToJSON,
  LinkedCompanyToJSONTyped,
} from "./LinkedCompany";
import type { CompanyIntegrations } from "./CompanyIntegrations";
import {
  CompanyIntegrationsFromJSON,
  CompanyIntegrationsFromJSONTyped,
  CompanyIntegrationsToJSON,
  CompanyIntegrationsToJSONTyped,
} from "./CompanyIntegrations";
import type { DashboardInvoiceWarningState } from "./DashboardInvoiceWarningState";
import {
  DashboardInvoiceWarningStateFromJSON,
  DashboardInvoiceWarningStateFromJSONTyped,
  DashboardInvoiceWarningStateToJSON,
  DashboardInvoiceWarningStateToJSONTyped,
} from "./DashboardInvoiceWarningState";
import type { CustomerSpecificPricingAgreement } from "./CustomerSpecificPricingAgreement";
import {
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementFromJSONTyped,
  CustomerSpecificPricingAgreementToJSON,
  CustomerSpecificPricingAgreementToJSONTyped,
} from "./CustomerSpecificPricingAgreement";
import type { Coupon } from "./Coupon";
import {
  CouponFromJSON,
  CouponFromJSONTyped,
  CouponToJSON,
  CouponToJSONTyped,
} from "./Coupon";
import type { StarredViewCompany } from "./StarredViewCompany";
import {
  StarredViewCompanyFromJSON,
  StarredViewCompanyFromJSONTyped,
  StarredViewCompanyToJSON,
  StarredViewCompanyToJSONTyped,
} from "./StarredViewCompany";
import type { CompanyQuotedShipmentRow } from "./CompanyQuotedShipmentRow";
import {
  CompanyQuotedShipmentRowFromJSON,
  CompanyQuotedShipmentRowFromJSONTyped,
  CompanyQuotedShipmentRowToJSON,
  CompanyQuotedShipmentRowToJSONTyped,
} from "./CompanyQuotedShipmentRow";
import type { SalesContactSimilarEmailElsewhere } from "./SalesContactSimilarEmailElsewhere";
import {
  SalesContactSimilarEmailElsewhereFromJSON,
  SalesContactSimilarEmailElsewhereFromJSONTyped,
  SalesContactSimilarEmailElsewhereToJSON,
  SalesContactSimilarEmailElsewhereToJSONTyped,
} from "./SalesContactSimilarEmailElsewhere";
import type { Experiment } from "./Experiment";
import {
  ExperimentFromJSON,
  ExperimentFromJSONTyped,
  ExperimentToJSON,
  ExperimentToJSONTyped,
} from "./Experiment";
import type { CustomerInvoice } from "./CustomerInvoice";
import {
  CustomerInvoiceFromJSON,
  CustomerInvoiceFromJSONTyped,
  CustomerInvoiceToJSON,
  CustomerInvoiceToJSONTyped,
} from "./CustomerInvoice";
import type { SavedLocation } from "./SavedLocation";
import {
  SavedLocationFromJSON,
  SavedLocationFromJSONTyped,
  SavedLocationToJSON,
  SavedLocationToJSONTyped,
} from "./SavedLocation";
import type { ShipmentDocument } from "./ShipmentDocument";
import {
  ShipmentDocumentFromJSON,
  ShipmentDocumentFromJSONTyped,
  ShipmentDocumentToJSON,
  ShipmentDocumentToJSONTyped,
} from "./ShipmentDocument";
import type { FreightClaim } from "./FreightClaim";
import {
  FreightClaimFromJSON,
  FreightClaimFromJSONTyped,
  FreightClaimToJSON,
  FreightClaimToJSONTyped,
} from "./FreightClaim";
import type { CompanyPaymentMethodInformation } from "./CompanyPaymentMethodInformation";
import {
  CompanyPaymentMethodInformationFromJSON,
  CompanyPaymentMethodInformationFromJSONTyped,
  CompanyPaymentMethodInformationToJSON,
  CompanyPaymentMethodInformationToJSONTyped,
} from "./CompanyPaymentMethodInformation";
import type { CompanyBookedShipmentRow } from "./CompanyBookedShipmentRow";
import {
  CompanyBookedShipmentRowFromJSON,
  CompanyBookedShipmentRowFromJSONTyped,
  CompanyBookedShipmentRowToJSON,
  CompanyBookedShipmentRowToJSONTyped,
} from "./CompanyBookedShipmentRow";
import type { CompanyWebhookResponse } from "./CompanyWebhookResponse";
import {
  CompanyWebhookResponseFromJSON,
  CompanyWebhookResponseFromJSONTyped,
  CompanyWebhookResponseToJSON,
  CompanyWebhookResponseToJSONTyped,
} from "./CompanyWebhookResponse";
import type { CompanyIntel } from "./CompanyIntel";
import {
  CompanyIntelFromJSON,
  CompanyIntelFromJSONTyped,
  CompanyIntelToJSON,
  CompanyIntelToJSONTyped,
} from "./CompanyIntel";
import type { CompanyNote } from "./CompanyNote";
import {
  CompanyNoteFromJSON,
  CompanyNoteFromJSONTyped,
  CompanyNoteToJSON,
  CompanyNoteToJSONTyped,
} from "./CompanyNote";
import type { SalesDashboard } from "./SalesDashboard";
import {
  SalesDashboardFromJSON,
  SalesDashboardFromJSONTyped,
  SalesDashboardToJSON,
  SalesDashboardToJSONTyped,
} from "./SalesDashboard";
import type { SalesContactNameElsewhere } from "./SalesContactNameElsewhere";
import {
  SalesContactNameElsewhereFromJSON,
  SalesContactNameElsewhereFromJSONTyped,
  SalesContactNameElsewhereToJSON,
  SalesContactNameElsewhereToJSONTyped,
} from "./SalesContactNameElsewhere";
import type { CompanyProblems } from "./CompanyProblems";
import {
  CompanyProblemsFromJSON,
  CompanyProblemsFromJSONTyped,
  CompanyProblemsToJSON,
  CompanyProblemsToJSONTyped,
} from "./CompanyProblems";
import type { MonthlyChartLine } from "./MonthlyChartLine";
import {
  MonthlyChartLineFromJSON,
  MonthlyChartLineFromJSONTyped,
  MonthlyChartLineToJSON,
  MonthlyChartLineToJSONTyped,
} from "./MonthlyChartLine";
import type { Sticky } from "./Sticky";
import {
  StickyFromJSON,
  StickyFromJSONTyped,
  StickyToJSON,
  StickyToJSONTyped,
} from "./Sticky";

/**
 *
 * @export
 * @interface CompanyData
 */
export interface CompanyData {
  /**
   *
   * @type {Company}
   * @memberof CompanyData
   */
  company: Company;
  /**
   *
   * @type {Array<MonthlyChartLine>}
   * @memberof CompanyData
   */
  shipmentsBookedPerMonth: Array<MonthlyChartLine>;
  /**
   *
   * @type {Array<MonthlyChartLine>}
   * @memberof CompanyData
   */
  shipmentsQuotedPerMonth: Array<MonthlyChartLine>;
  /**
   *
   * @type {Array<CompanyBookedShipmentRow>}
   * @memberof CompanyData
   */
  bookedShipments: Array<CompanyBookedShipmentRow>;
  /**
   *
   * @type {Array<CompanyQuotedShipmentRow>}
   * @memberof CompanyData
   */
  quotedShipments: Array<CompanyQuotedShipmentRow>;
  /**
   *
   * @type {Array<Coupon>}
   * @memberof CompanyData
   */
  coupons: Array<Coupon>;
  /**
   *
   * @type {Coupon}
   * @memberof CompanyData
   */
  bestCoupon: Coupon;
  /**
   *
   * @type {CompanyPaymentMethodInformation}
   * @memberof CompanyData
   */
  paymentMethodInfo: CompanyPaymentMethodInformation;
  /**
   *
   * @type {Array<CustomerInvoice>}
   * @memberof CompanyData
   */
  customerInvoices: Array<CustomerInvoice>;
  /**
   *
   * @type {DashboardInvoiceWarningState}
   * @memberof CompanyData
   */
  invoiceWarningState: DashboardInvoiceWarningState;
  /**
   *
   * @type {Array<CompanyNote>}
   * @memberof CompanyData
   */
  companyNotes: Array<CompanyNote>;
  /**
   *
   * @type {Array<SalesContact>}
   * @memberof CompanyData
   */
  salesContacts: Array<SalesContact>;
  /**
   *
   * @type {Array<SalesContactNameElsewhere>}
   * @memberof CompanyData
   */
  salesContactNamesElsewhere?: Array<SalesContactNameElsewhere> | null;
  /**
   *
   * @type {Array<SalesContactSimilarEmailElsewhere>}
   * @memberof CompanyData
   */
  salesContactSimilarEmailsElsewhere?: Array<SalesContactSimilarEmailElsewhere> | null;
  /**
   *
   * @type {Array<ApiKey>}
   * @memberof CompanyData
   */
  apiKeys: Array<ApiKey>;
  /**
   *
   * @type {Array<CompanyProblems>}
   * @memberof CompanyData
   */
  companyProblems: Array<CompanyProblems>;
  /**
   *
   * @type {Array<CustomerSpecificPricingAgreement>}
   * @memberof CompanyData
   */
  pricingAgreements: Array<CustomerSpecificPricingAgreement>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyData
   */
  companyLabelIds: Array<string>;
  /**
   *
   * @type {Array<CompanyDocument>}
   * @memberof CompanyData
   */
  companyDocuments: Array<CompanyDocument>;
  /**
   *
   * @type {Array<ShipmentDocument>}
   * @memberof CompanyData
   */
  shipmentPhotos: Array<ShipmentDocument>;
  /**
   *
   * @type {Array<FreightClaim>}
   * @memberof CompanyData
   */
  companyClaims: Array<FreightClaim>;
  /**
   *
   * @type {SalesDashboard}
   * @memberof CompanyData
   */
  salesDashboard: SalesDashboard;
  /**
   *
   * @type {Array<CompanyWebhookResponse>}
   * @memberof CompanyData
   */
  webhooks: Array<CompanyWebhookResponse>;
  /**
   *
   * @type {Array<SavedLocation>}
   * @memberof CompanyData
   */
  addressBook: Array<SavedLocation>;
  /**
   *
   * @type {Array<LinkedCompany>}
   * @memberof CompanyData
   */
  linkedCompanies: Array<LinkedCompany>;
  /**
   *
   * @type {Array<Sticky>}
   * @memberof CompanyData
   */
  companyStickies?: Array<Sticky> | null;
  /**
   *
   * @type {StarredViewCompany}
   * @memberof CompanyData
   */
  starredCompany: StarredViewCompany;
  /**
   *
   * @type {Array<Experiment>}
   * @memberof CompanyData
   */
  experiments: Array<Experiment>;
  /**
   *
   * @type {CompanyIntel}
   * @memberof CompanyData
   */
  companyIntel?: CompanyIntel | null;
  /**
   *
   * @type {Array<AgentTaskRun>}
   * @memberof CompanyData
   */
  recentAgentTaskRuns?: Array<AgentTaskRun> | null;
  /**
   *
   * @type {CompanyIntegrations}
   * @memberof CompanyData
   */
  integrations: CompanyIntegrations;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyData
   */
  permittedContactEmailDomains?: Array<string> | null;
}

/**
 * Check if a given object implements the CompanyData interface.
 */
export function instanceOfCompanyData(value: object): value is CompanyData {
  if (!("company" in value) || value["company"] === undefined) return false;
  if (
    !("shipmentsBookedPerMonth" in value) ||
    value["shipmentsBookedPerMonth"] === undefined
  )
    return false;
  if (
    !("shipmentsQuotedPerMonth" in value) ||
    value["shipmentsQuotedPerMonth"] === undefined
  )
    return false;
  if (!("bookedShipments" in value) || value["bookedShipments"] === undefined)
    return false;
  if (!("quotedShipments" in value) || value["quotedShipments"] === undefined)
    return false;
  if (!("coupons" in value) || value["coupons"] === undefined) return false;
  if (!("bestCoupon" in value) || value["bestCoupon"] === undefined)
    return false;
  if (
    !("paymentMethodInfo" in value) ||
    value["paymentMethodInfo"] === undefined
  )
    return false;
  if (!("customerInvoices" in value) || value["customerInvoices"] === undefined)
    return false;
  if (
    !("invoiceWarningState" in value) ||
    value["invoiceWarningState"] === undefined
  )
    return false;
  if (!("companyNotes" in value) || value["companyNotes"] === undefined)
    return false;
  if (!("salesContacts" in value) || value["salesContacts"] === undefined)
    return false;
  if (!("apiKeys" in value) || value["apiKeys"] === undefined) return false;
  if (!("companyProblems" in value) || value["companyProblems"] === undefined)
    return false;
  if (
    !("pricingAgreements" in value) ||
    value["pricingAgreements"] === undefined
  )
    return false;
  if (!("companyLabelIds" in value) || value["companyLabelIds"] === undefined)
    return false;
  if (!("companyDocuments" in value) || value["companyDocuments"] === undefined)
    return false;
  if (!("shipmentPhotos" in value) || value["shipmentPhotos"] === undefined)
    return false;
  if (!("companyClaims" in value) || value["companyClaims"] === undefined)
    return false;
  if (!("salesDashboard" in value) || value["salesDashboard"] === undefined)
    return false;
  if (!("webhooks" in value) || value["webhooks"] === undefined) return false;
  if (!("addressBook" in value) || value["addressBook"] === undefined)
    return false;
  if (!("linkedCompanies" in value) || value["linkedCompanies"] === undefined)
    return false;
  if (!("starredCompany" in value) || value["starredCompany"] === undefined)
    return false;
  if (!("experiments" in value) || value["experiments"] === undefined)
    return false;
  if (!("integrations" in value) || value["integrations"] === undefined)
    return false;
  return true;
}

export function CompanyDataFromJSON(json: any): CompanyData {
  return CompanyDataFromJSONTyped(json, false);
}

export function CompanyDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyData {
  if (json == null) {
    return json;
  }
  return {
    company: CompanyFromJSON(json["company"]),
    shipmentsBookedPerMonth: (
      json["shipmentsBookedPerMonth"] as Array<any>
    ).map(MonthlyChartLineFromJSON),
    shipmentsQuotedPerMonth: (
      json["shipmentsQuotedPerMonth"] as Array<any>
    ).map(MonthlyChartLineFromJSON),
    bookedShipments: (json["bookedShipments"] as Array<any>).map(
      CompanyBookedShipmentRowFromJSON,
    ),
    quotedShipments: (json["quotedShipments"] as Array<any>).map(
      CompanyQuotedShipmentRowFromJSON,
    ),
    coupons: (json["coupons"] as Array<any>).map(CouponFromJSON),
    bestCoupon: CouponFromJSON(json["bestCoupon"]),
    paymentMethodInfo: CompanyPaymentMethodInformationFromJSON(
      json["paymentMethodInfo"],
    ),
    customerInvoices: (json["customerInvoices"] as Array<any>).map(
      CustomerInvoiceFromJSON,
    ),
    invoiceWarningState: DashboardInvoiceWarningStateFromJSON(
      json["invoiceWarningState"],
    ),
    companyNotes: (json["companyNotes"] as Array<any>).map(CompanyNoteFromJSON),
    salesContacts: (json["salesContacts"] as Array<any>).map(
      SalesContactFromJSON,
    ),
    salesContactNamesElsewhere:
      json["salesContactNamesElsewhere"] == null
        ? undefined
        : (json["salesContactNamesElsewhere"] as Array<any>).map(
            SalesContactNameElsewhereFromJSON,
          ),
    salesContactSimilarEmailsElsewhere:
      json["salesContactSimilarEmailsElsewhere"] == null
        ? undefined
        : (json["salesContactSimilarEmailsElsewhere"] as Array<any>).map(
            SalesContactSimilarEmailElsewhereFromJSON,
          ),
    apiKeys: (json["apiKeys"] as Array<any>).map(ApiKeyFromJSON),
    companyProblems: (json["companyProblems"] as Array<any>).map(
      CompanyProblemsFromJSON,
    ),
    pricingAgreements: (json["pricingAgreements"] as Array<any>).map(
      CustomerSpecificPricingAgreementFromJSON,
    ),
    companyLabelIds: json["companyLabelIds"],
    companyDocuments: (json["companyDocuments"] as Array<any>).map(
      CompanyDocumentFromJSON,
    ),
    shipmentPhotos: (json["shipmentPhotos"] as Array<any>).map(
      ShipmentDocumentFromJSON,
    ),
    companyClaims: (json["companyClaims"] as Array<any>).map(
      FreightClaimFromJSON,
    ),
    salesDashboard: SalesDashboardFromJSON(json["salesDashboard"]),
    webhooks: (json["webhooks"] as Array<any>).map(
      CompanyWebhookResponseFromJSON,
    ),
    addressBook: (json["addressBook"] as Array<any>).map(SavedLocationFromJSON),
    linkedCompanies: (json["linkedCompanies"] as Array<any>).map(
      LinkedCompanyFromJSON,
    ),
    companyStickies:
      json["companyStickies"] == null
        ? undefined
        : (json["companyStickies"] as Array<any>).map(StickyFromJSON),
    starredCompany: StarredViewCompanyFromJSON(json["starredCompany"]),
    experiments: (json["experiments"] as Array<any>).map(ExperimentFromJSON),
    companyIntel:
      json["companyIntel"] == null
        ? undefined
        : CompanyIntelFromJSON(json["companyIntel"]),
    recentAgentTaskRuns:
      json["recentAgentTaskRuns"] == null
        ? undefined
        : (json["recentAgentTaskRuns"] as Array<any>).map(AgentTaskRunFromJSON),
    integrations: CompanyIntegrationsFromJSON(json["integrations"]),
    permittedContactEmailDomains:
      json["permittedContactEmailDomains"] == null
        ? undefined
        : json["permittedContactEmailDomains"],
  };
}

export function CompanyDataToJSON(json: any): CompanyData {
  return CompanyDataToJSONTyped(json, false);
}

export function CompanyDataToJSONTyped(
  value?: CompanyData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    company: CompanyToJSON(value["company"]),
    shipmentsBookedPerMonth: (
      value["shipmentsBookedPerMonth"] as Array<any>
    ).map(MonthlyChartLineToJSON),
    shipmentsQuotedPerMonth: (
      value["shipmentsQuotedPerMonth"] as Array<any>
    ).map(MonthlyChartLineToJSON),
    bookedShipments: (value["bookedShipments"] as Array<any>).map(
      CompanyBookedShipmentRowToJSON,
    ),
    quotedShipments: (value["quotedShipments"] as Array<any>).map(
      CompanyQuotedShipmentRowToJSON,
    ),
    coupons: (value["coupons"] as Array<any>).map(CouponToJSON),
    bestCoupon: CouponToJSON(value["bestCoupon"]),
    paymentMethodInfo: CompanyPaymentMethodInformationToJSON(
      value["paymentMethodInfo"],
    ),
    customerInvoices: (value["customerInvoices"] as Array<any>).map(
      CustomerInvoiceToJSON,
    ),
    invoiceWarningState: DashboardInvoiceWarningStateToJSON(
      value["invoiceWarningState"],
    ),
    companyNotes: (value["companyNotes"] as Array<any>).map(CompanyNoteToJSON),
    salesContacts: (value["salesContacts"] as Array<any>).map(
      SalesContactToJSON,
    ),
    salesContactNamesElsewhere:
      value["salesContactNamesElsewhere"] == null
        ? undefined
        : (value["salesContactNamesElsewhere"] as Array<any>).map(
            SalesContactNameElsewhereToJSON,
          ),
    salesContactSimilarEmailsElsewhere:
      value["salesContactSimilarEmailsElsewhere"] == null
        ? undefined
        : (value["salesContactSimilarEmailsElsewhere"] as Array<any>).map(
            SalesContactSimilarEmailElsewhereToJSON,
          ),
    apiKeys: (value["apiKeys"] as Array<any>).map(ApiKeyToJSON),
    companyProblems: (value["companyProblems"] as Array<any>).map(
      CompanyProblemsToJSON,
    ),
    pricingAgreements: (value["pricingAgreements"] as Array<any>).map(
      CustomerSpecificPricingAgreementToJSON,
    ),
    companyLabelIds: value["companyLabelIds"],
    companyDocuments: (value["companyDocuments"] as Array<any>).map(
      CompanyDocumentToJSON,
    ),
    shipmentPhotos: (value["shipmentPhotos"] as Array<any>).map(
      ShipmentDocumentToJSON,
    ),
    companyClaims: (value["companyClaims"] as Array<any>).map(
      FreightClaimToJSON,
    ),
    salesDashboard: SalesDashboardToJSON(value["salesDashboard"]),
    webhooks: (value["webhooks"] as Array<any>).map(
      CompanyWebhookResponseToJSON,
    ),
    addressBook: (value["addressBook"] as Array<any>).map(SavedLocationToJSON),
    linkedCompanies: (value["linkedCompanies"] as Array<any>).map(
      LinkedCompanyToJSON,
    ),
    companyStickies:
      value["companyStickies"] == null
        ? undefined
        : (value["companyStickies"] as Array<any>).map(StickyToJSON),
    starredCompany: StarredViewCompanyToJSON(value["starredCompany"]),
    experiments: (value["experiments"] as Array<any>).map(ExperimentToJSON),
    companyIntel: CompanyIntelToJSON(value["companyIntel"]),
    recentAgentTaskRuns:
      value["recentAgentTaskRuns"] == null
        ? undefined
        : (value["recentAgentTaskRuns"] as Array<any>).map(AgentTaskRunToJSON),
    integrations: CompanyIntegrationsToJSON(value["integrations"]),
    permittedContactEmailDomains: value["permittedContactEmailDomains"],
  };
}
